import { t } from "../../i18n";
import { billingPageStyles as s } from "./billing-page-styles";

type BillingTab = "user-billing" | "agent-commerce";

export function BillingTabs({
  active,
  onChange,
}: {
  active: BillingTab;
  onChange: (tab: BillingTab) => void;
}): React.JSX.Element {
  return (
    <div style={s.tabBar}>
      <BillingTabButton
        active={active === "user-billing"}
        label={t("billing.tab_user_billing")}
        onClick={() => onChange("user-billing")}
      />
      <BillingTabButton
        active={active === "agent-commerce"}
        label={t("billing.tab_agent_commerce")}
        onClick={() => onChange("agent-commerce")}
      />
    </div>
  );
}

function BillingTabButton({
  active,
  label,
  onClick,
}: {
  active: boolean;
  label: string;
  onClick: () => void;
}): React.JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      style={active ? { ...s.tab, ...s.tabActive } : s.tab}
    >
      {label}
    </button>
  );
}
